import React from 'react'
import ChangepasswordForm from '../../components/others/global/changepassword'


const Changepassword = () => {
  const User = JSON.parse(localStorage.getItem("user-info"));
  return (
    <>
      <div className='admin_forms_row'>
          <div className='admin_col_50'></div>
          <div className='admin_col_50'>
            <ChangepasswordForm Username = {User.username}/>
          </div>
      </div>
    </>
  )
}

export default Changepassword
